import ambiente from "../services/ambiente";

const captchaKey = {
    key: ambiente.CAPTCHA_KEY
}

export default captchaKey;

